<template>
  <div class="grid2col" @click="toggleExpand">
    <div>{{ showing.date }} <img alt="icon" src="../../assets/icons/pen.svg" @click="edit"><br>
      <span class="fs-14">
                <span class="opaque-60">{{ showing.time }}</span>
              </span>
    </div>
    <div class="text-right">
      <div>
        <span v-if="showing.started">{{ showing.joined }} deltog</span>
        <span v-else>{{ showing.attendees }} anmälda</span>

        <br><span class="fs-14 opaque-60">{{ showing.showingComment }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import newShowing from '../forms/visningar/newShowing';

export default {
  props: {
    showing: Object,
    toggleExpand: Function,
  },
  name: 'ShowingHeader',
  data() {
    return {};
  },
  methods: {
    async edit() {
      this.$root.loader = true;
      this.$store.commit("showing/STORE_CURRENT_SHOWING", null);
      await this.$store.dispatch('showing/storeCurrentShowing', { id: this.showing.id }).then(() => this.openActiveComponent());
    },
    openActiveComponent() {
      this.$root.loader = false;
      this.$store.commit('STORE_ACTIVE_COMPONENT', newShowing)
      this.$root.modalOpen = true;
    }
  }
};
</script>

<style>
</style>
